(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[313],{

/***/ 94755:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/messages",
      function () {
        return __webpack_require__(27306);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_messages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 6 modules
var styled = __webpack_require__(58271);
// EXTERNAL MODULE: ./node_modules/@mui/material/TablePagination/TablePagination.js + 71 modules
var TablePagination = __webpack_require__(19989);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(28368);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(62469);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 4 modules
var popover = __webpack_require__(61761);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(17106);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/filters/FilterDropdown.tsx





function FilterDropdown(param) {
    let { name , children , onSubmit , onClear , active =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
        as: "div",
        className: "relative inline-block",
        children: (param)=>/*#__PURE__*/ {
            let { close  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                            className: (0,clsx_m/* default */.Z)("group inline-flex justify-center text-sm font-medium"),
                            children: [
                                name,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronDownIcon */.v4q, {
                                    className: (0,clsx_m/* default */.Z)("-mr-1 ml-1 h-5 w-5 flex-shrink-0"),
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        as: react.Fragment,
                        enter: "transition ease-out duration-100",
                        enterFrom: "transform opacity-0 scale-95",
                        enterTo: "transform opacity-100 scale-100",
                        leave: "transition ease-in duration-75",
                        leaveFrom: "transform opacity-100 scale-100",
                        leaveTo: "transform opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                            focus: true,
                            className: "absolute left-1/2 z-50 mt-2 w-max origin-top rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none lg:-translate-x-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    onSubmit(close);
                                },
                                className: "space-y-2 p-4",
                                children: [
                                    children,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-x-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                className: "inline-flex items-center rounded-md border border-transparent bg-slate-900 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2",
                                                children: "Apply"
                                            }),
                                            active && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>onClear(close),
                                                className: "inline-flex items-center rounded-md border border-transparent bg-red-100 px-3 py-2 text-sm font-medium leading-4 text-red-700 shadow-sm hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2",
                                                children: "Clear"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            });
        }
    });
}

// EXTERNAL MODULE: ./node_modules/@ethersproject/address/lib.esm/index.js + 8 modules
var lib_esm = __webpack_require__(46802);
// EXTERNAL MODULE: ./src/util/util.ts
var util = __webpack_require__(16772);
;// CONCATENATED MODULE: ./src/components/filters/AddressInputFilter.tsx






function AddressInputFilter(param) {
    let { name , value , setValue  } = param;
    const [input, setInput] = (0,react.useState)(value);
    const [error, setError] = (0,react.useState)(false);
    const onClear = (close)=>{
        close();
        setValue("");
    };
    const onSubmit = (close)=>{
        let address = "";
        if (input !== "") {
            try {
                address = lib_esm/* getAddress */.Kn(input);
            } catch (e) {
                setError(true);
                return;
            }
        }
        close();
        setValue(address);
    };
    const displayName = value ? "".concat(name, ": ").concat((0,util/* shorten */.OV)(value, 6, 4)) : "".concat(name, " Address");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown, {
        name: displayName,
        active: Boolean(value),
        onSubmit: onSubmit,
        onClear: onClear,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "block text-sm text-gray-900",
                children: [
                    name,
                    " Address",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: (0,clsx_m/* default */.Z)("mt-2 block w-full rounded-md border border-gray-300 p-1 font-normal shadow-sm focus:border-succinct-black focus:ring-succinct-black sm:text-sm", error && "border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500"),
                        value: input,
                        onChange: (e)=>{
                            setError(false);
                            setInput(e.target.value);
                        },
                        "aria-invalid": error
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 5 modules
var listbox = __webpack_require__(64857);
// EXTERNAL MODULE: ./src/lib/chains.ts
var chains = __webpack_require__(90380);
;// CONCATENATED MODULE: ./src/components/filters/ChainSelectFilter.tsx







function ChainSelectFilter(param) {
    let { name , options , value , setValue  } = param;
    const [selected, setSelected] = (0,react.useState)(value);
    const active = value.length < options.length;
    const displayName = "".concat(name, " Chain") + (active ? ": " + value.map((c)=>chains/* default */.ZP[c].name).join(", ") : "");
    const onSubmit = (close)=>{
        setValue(selected);
        close();
    };
    const onClear = (close)=>{
        setValue(null);
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown, {
        name: displayName,
        active: active,
        onSubmit: onSubmit,
        onClear: onClear,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "block text-sm text-gray-700",
                children: [
                    name,
                    " Chains",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
                        value: selected,
                        onChange: setSelected,
                        multiple: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative mt-2 overflow-hidden rounded-md border border-gray-300 text-sm shadow-sm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                    static: true,
                                    className: "z-10 max-h-60 w-full overflow-auto bg-white text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                    children: options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                            className: "group relative cursor-pointer select-none py-2 pl-8 pr-4 text-gray-900 hover:bg-succinct-teal-20 hover:text-white",
                                            value: option.id,
                                            children: (param)=>/*#__PURE__*/ {
                                                let { selected  } = param;
                                                return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (0,clsx_m/* default */.Z)("block truncate font-normal"),
                                                            children: option.name
                                                        }),
                                                        selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (0,clsx_m/* default */.Z)("absolute inset-y-0 left-0 flex items-center pl-1.5 text-succinct-teal-20 group-hover:text-white"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CheckIcon */.nQG, {
                                                                className: "h-5 w-5",
                                                                "aria-hidden": "true"
                                                            })
                                                        }) : null
                                                    ]
                                                });
                                            }
                                        }, option.id))
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers-pro/StaticDateRangePicker/StaticDateRangePicker.js + 78 modules
var StaticDateRangePicker = __webpack_require__(524);
;// CONCATENATED MODULE: ./src/components/filters/DateRangeFilter.tsx





function DateRangeFilter(param) {
    let { name , value , setValue  } = param;
    const active = value[0] !== null && value[1] !== null;
    const displayName = active ? (0,util/* formatDateUTC */.Rm)(value[0]) + " - " + (0,util/* formatDateUTC */.Rm)(value[1]) : name;
    const [date, setDate] = (0,react.useState)(value);
    const onClear = (close)=>{
        close();
        setValue([
            null,
            null
        ]);
    };
    const onSubmit = (close)=>{
        close();
        setValue(date);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown, {
        name: displayName,
        onSubmit: onSubmit,
        onClear: onClear,
        active: active,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            className: "block font-medium text-gray-700",
            children: [
                name,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticDateRangePicker/* StaticDateRangePicker */.u, {
                    displayStaticWrapperAs: "desktop",
                    calendars: 1,
                    value: date,
                    onChange: (range)=>setDate(range),
                    maxDate: new Date(),
                    closeOnSelect: false,
                    renderInput: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/filters/Filters.tsx






function Filters(param) {
    let { chainOptions , filters , setFilters , reset  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-4 flex max-w-full flex-col items-start space-y-2 text-lg text-white lg:flex-row lg:items-center lg:space-y-0 lg:space-x-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                    as: "button",
                    className: "inline-flex items-center rounded-md border border-transparent bg-gray-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm ring-offset-succinct-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* MixerHorizontalIcon */.hsZ, {
                            className: "-ml-0.5 mr-2 h-4 w-4",
                            "aria-hidden": "true"
                        }),
                        "Filters"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Panel */.p.Panel, {
                    className: "flex flex-col items-start space-y-4 lg:flex-row lg:items-center lg:space-y-0 lg:space-x-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainSelectFilter, {
                            name: "Target",
                            options: chainOptions,
                            value: filters.chain,
                            setValue: (val)=>setFilters({
                                    chain: val
                                })
                        }, "TargetChain_" + filters.chain.join(",")),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputFilter, {
                            name: "Origin",
                            value: filters.origin,
                            setValue: (val)=>setFilters({
                                    origin: val
                                })
                        }, "OriginAddress_" + filters.origin),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputFilter, {
                            name: "Source",
                            value: filters.source,
                            setValue: (val)=>setFilters({
                                    source: val
                                })
                        }, "SourceAddress_" + filters.source),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputFilter, {
                            name: "Target",
                            value: filters.target,
                            setValue: (val)=>setFilters({
                                    target: val
                                })
                        }, "TargetAddress_" + filters.target),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeFilter, {
                            name: "Date",
                            value: [
                                filters.startDate,
                                filters.endDate
                            ],
                            setValue: (param)=>{
                                let [start, end] = param;
                                return setFilters({
                                    startDate: start,
                                    endDate: end
                                });
                            }
                        }, "Date_" + ((ref = filters.startDate) === null || ref === void 0 ? void 0 : ref.toString()))
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/messagesTable/MessagesTable.tsx + 1 modules
var MessagesTable = __webpack_require__(5559);
// EXTERNAL MODULE: ./src/hooks/messages.ts
var messages = __webpack_require__(29521);
// EXTERNAL MODULE: ./src/hooks/sourceChain.ts
var hooks_sourceChain = __webpack_require__(10024);
// EXTERNAL MODULE: ./src/lib/NoSSR.tsx
var NoSSR = __webpack_require__(89780);
// EXTERNAL MODULE: ./src/lib/types.ts
var types = __webpack_require__(20982);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 40 modules
var parse = __webpack_require__(42034);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/next-usequerystate/dist/esm/index.js + 3 modules
var esm = __webpack_require__(34062);
;// CONCATENATED MODULE: ./src/lib/useQueryState.ts



// Wrap next-useQueryState so that setting the state back to default
// removes it from URL query params by passing null to useQueryState's setter
function useQueryState(key, options) {
    const [val, setVal] = (0,esm/* useQueryState */.v1)(key, options);
    const wrapperSetVal = async (newVal)=>{
        if (newVal === null || newVal === options.defaultValue || Array.isArray(newVal) && (0,util/* arraySetEquality */.ab)(newVal, val)) {
            await setVal(null);
        } else {
            await setVal(newVal);
        }
    };
    return [
        val,
        wrapperSetVal
    ];
}
const dayQueryType = {
    parse: (query)=>query === "" ? null : (0,parse/* default */.Z)(query, "MM-dd-yyyy", new Date(0)),
    serialize: (date)=>date === null ? "" : (0,format/* default */.Z)(date, "MM-dd-yyyy"),
    defaultValue: null
};

;// CONCATENATED MODULE: ./src/pages/messages.tsx












// The Graph limits the skip param to 5000 so that's the max pages we can handle
const THE_GRAPH_MAX_SKIP = 5000;
const messages_TablePagination = (0,styled/* default */.ZP)(TablePagination/* default */.Z)({
    "& .MuiTablePagination-toolbar": {
        padding: 0
    },
    ".MuiInputBase-root": {
        marginRight: "4px"
    }
});
const Messages = ()=>{
    const sourceChain = (0,react.useContext)(hooks_sourceChain/* SourceChainContext */.N);
    // Filters
    const chainOptions = chains/* DESTINATION_CHAINS */.Bc[sourceChain].map((c)=>({
            id: c,
            name: chains/* default */.ZP[c].name
        })) || [];
    const [filters, setFilters] = (0,esm/* useQueryStates */.XI)({
        chain: esm/* queryTypes.array */.SS.array(esm/* queryTypes.stringEnum */.SS.stringEnum(chainOptions.map((c)=>c.id)), " ").withDefault(chainOptions.map((o)=>o.id)),
        origin: esm/* queryTypes.string.withDefault */.SS.string.withDefault(""),
        source: esm/* queryTypes.string.withDefault */.SS.string.withDefault(""),
        target: esm/* queryTypes.string.withDefault */.SS.string.withDefault(""),
        startDate: dayQueryType,
        endDate: dayQueryType
    });
    const reset = async ()=>{
        await setFilters(types/* DefaultMessageTableFilters */.m);
        setCurrentPage(1);
    };
    // Pagination
    const [currentPage, setCurrentPage] = useQueryState("page", esm/* queryTypes.integer.withDefault */.SS.integer.withDefault(1));
    const [pageSize, setPageSize] = useQueryState("pageCount", esm/* queryTypes.integer.withDefault */.SS.integer.withDefault(50));
    if (currentPage < 1) {
        setCurrentPage(1);
    }
    if (currentPage > THE_GRAPH_MAX_SKIP / pageSize) {
        setCurrentPage(THE_GRAPH_MAX_SKIP / pageSize);
    }
    const handleChangePage = (_, page)=>{
        setCurrentPage(page + 1);
    };
    const handleChangeRowsPerPage = (e)=>{
        setPageSize(parseInt(e.target.value));
    };
    const labelDisplayedRows = ()=>{
        return "Page ".concat(currentPage);
    };
    // Fetch data whenever pagination/filters change
    const [sentMessages, loadingSentMessages] = (0,messages/* useSentMessagesQuery */.RM)(currentPage, pageSize, filters, sourceChain);
    const [executedMessages] = (0,messages/* useExecutedMessagesQuery */.Tk)(sentMessages, sourceChain);
    const [latestHeadUpdates] = (0,messages/* useLatestHeadUpdates */.c_)(sourceChain);
    const lastFinalizedBlock = (0,messages/* useLastFinalizedBlock */.WQ)(sourceChain);
    const rows = sentMessages.map((msg)=>{
        return [
            msg,
            executedMessages.size > 0 && executedMessages.get(msg === null || msg === void 0 ? void 0 : msg.messageNonce) || null
        ];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSSR/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {
                        filters: filters,
                        setFilters: setFilters,
                        chainOptions: chainOptions,
                        reset: reset
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessagesTable/* default */.Z, {
                        loading: loadingSentMessages,
                        rows: rows,
                        latestHeadUpdates: latestHeadUpdates,
                        lastFinalizedBlock: lastFinalizedBlock
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(messages_TablePagination, {
                        component: "div",
                        className: "border-none",
                        count: -1,
                        page: currentPage - 1,
                        onPageChange: handleChangePage,
                        onRowsPerPageChange: handleChangeRowsPerPage,
                        labelDisplayedRows: labelDisplayedRows,
                        rowsPerPage: pageSize,
                        nextIconButtonProps: {
                            disabled: rows.length < pageSize || currentPage >= THE_GRAPH_MAX_SKIP / pageSize
                        },
                        style: {
                            color: "white",
                            border: " none"
                        }
                    })
                ]
            })
        })
    });
};
Messages.header = "Messages";
/* harmony default export */ var pages_messages = (Messages);


/***/ }),

/***/ 46601:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [874,212,277,989,528,814,378,501,774,888,179], function() { return __webpack_exec__(94755); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);